import { Toaster } from 'react-hot-toast';

import { ApolloProvider } from '@apollo/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import Cookies from 'universal-cookie';

import { init18n } from '@spacefill/shared/src/i18n/I18n';
import { client as ApolloClient } from '@spacefill/shared/src/utils/Apollo';
import { BeamerProvider } from '@spacefill/shared/src/utils/Beamer';
import { BrandPreviewContextProvider } from '@spacefill/shared/src/utils/BrandContext';
import { FeatureTogglingProvider } from '@spacefill/shared/src/utils/FeatureToggling';
import { SideBarContextProvider } from '@spacefill/shared/src/utils/SideBarContext';
import { TopBannerContextProvider } from '@spacefill/shared/src/utils/TopBannerContext';
import { UserProvider } from '@spacefill/shared/src/utils/UserContext';
import '@spacefill/shared/src/utils/YupMethods';

import { featureSettings } from './Features';
import { RouterContext } from './router/RouterContext';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});
const cookies = new Cookies();

init18n();

const App = () => {
    // Need to put it here because Apollo rerender at login and when in
    // impersonate mode it removes cookies before user is connected
    if (new URL(window.location.href).searchParams.get('impersonateUserId')) {
        cookies.remove('jwtTokenExternalConsole', {
            domain: document.domain,
            path: '/',
        });
        cookies.remove('jwtTokenExternalConsoleImpersonator', {
            domain: document.domain,
            path: '/',
        });
        cookies.remove('jwtTokenRememberMe', {
            domain: document.domain,
            path: '/',
        });
    }

    return (
        <QueryClientProvider client={queryClient}>
            <ApolloProvider client={ApolloClient}>
                <BrandPreviewContextProvider>
                    <TopBannerContextProvider>
                        <SideBarContextProvider>
                            <UserProvider>
                                <BeamerProvider>
                                    <FeatureTogglingProvider featureSettings={featureSettings}>
                                        <RouterContext />
                                        <Toaster />
                                    </FeatureTogglingProvider>
                                </BeamerProvider>
                            </UserProvider>
                        </SideBarContextProvider>
                    </TopBannerContextProvider>
                </BrandPreviewContextProvider>
            </ApolloProvider>
            {import.meta.env?.VITE_EXTERNAL_CONSOLE_REACT_QUERY_DEVTOOLS_ENABLED && (
                <ReactQueryDevtools initialIsOpen />
            )}
        </QueryClientProvider>
    );
};

export { App };
